module.exports = __webpack_public_path__ + "img/philadelphia.32cc9e71.png";